import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import validator from 'validator'
import { withRouter } from 'react-router-dom'
import ReactGA from 'react-ga'
import { find } from 'lodash'

import Input from '../../components/input'
import Radio from '../../components/input'
import { Button, Card } from '../../components'
import { Link } from 'react-router-dom'

// import LoginLinkedIn from '../containers/login-linkedin'
import countries from '../../utils/countries'
import { isNameValid, scrollParentFrame } from '../../utils/methods'

import {
  setLinkedInAuthCode,
  getLinkedInProfile,
  registerUser,
  save,
  hubSpotApi
} from '../../actions'

class Register extends Component {
  state = {
    firstName: this.props.firstName,
    lastName: this.props.lastName,
    email: '',
    phone: '',
    country: this.props.country,
    countryState: this.props.countryState,
    firstNameValid: true,
    lastNameValid: true,
    emailValid: true,
    phoneValid: true,
    countryValid: true,
    countryStateValid: true,
    privacyPolicy: null,
    privacyPolicyGmac: null,
    countryStateList: []
  }

  componentDidMount() {
    this.validateStep()
    window.scrollTo(0, 0)
    scrollParentFrame()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      this.validateStep()
    }
  }

  validateStep() {
    const {
      firstName,
      lastName,
      email,
      country,
      privacyPolicy,
      privacyPolicyGmac,
      phone
    } = this.props

    if (
      firstName &&
      lastName &&
      email &&
      country &&
      privacyPolicy &&
      phone &&
      privacyPolicyGmac
    )
      this.props.history.replace('/report')
  }

  checkLinkedInToken() {
    const { linkedinToken } = this.props
    if (linkedinToken && linkedinToken.access_token) {
      const expireDate = moment.utc(linkedinToken.expires_at)
      const currentDate = moment.utc()
      if (!currentDate.isSameOrAfter(expireDate, 'minute')) {
        return true
      }
    }
    return false
  }

  handleFailure = error => {
    console.error(error)
  }

  onFirstNameChange = event => {
    this.setState({ firstName: event.target.value })
  }

  onLastNameChange = event => {
    this.setState({ lastName: event.target.value })
  }

  onEmailChange = event => {
    this.setState({ email: event.target.value })
  }

  onPhoneChange = event => {
    this.setState({ phone: event.target.value })
  }

  getCountryStates(countryCode) {
    const country = find(countries, c => c.code === countryCode)

    return (country && country.states) || []
  }

  onCountryChange = event => {
    const countryStateList = this.getCountryStates(event.target.value)
    this.setState({
      country: event.target.value,
      countryStateList,
      countryState: '',
      countryValid: event.target.value,
      countryStateValid: countryStateList.length === 0
    })
  }

  onStateChange = event => {
    this.setState({
      countryState: event.target.value,
      countryStateValid: event.target.value
    })
  }

  onChecked = event => {
    this.setState({ privacyPolicy: true })
  }
  onUnchecked = event => {
    this.setState({ privacyPolicy: false })
  }

  onCheckedGmac = event => {
    this.setState({ privacyPolicyGmac: true })
  }

  onUncheckedGmac = event => {
    this.setState({ privacyPolicyGmac: false })
  }

  register = () => {
    const {
      firstName,
      lastName,
      email,
      phone,
      country,
      countryState,
      privacyPolicy,
      privacyPolicyGmac
    } = this.state

    this.props.callRegister({
      firstName,
      lastName,
      email,
      phone,
      country,
      countryState,
      privacyPolicy,
      privacyPolicyGmac
    })

    if (privacyPolicyGmac) {
      this.props.callHubSportApi({
        firstName,
        lastName,
        email,
        phone,
        country,
        privacyPolicyGmac
      })
    }

    ReactGA.event({
      category: 'User',
      action: 'Registration'
    })

    this.props.history.replace('/career-explorer/report')
  }

  showFooter() {
    const {
      privacyPolicy,
      privacyPolicyGmac,
      firstName,
      lastName,
      email,
      phone,
      country
    } = this.state

    return (
      (privacyPolicy === false && privacyPolicyGmac === false) ||
      ((privacyPolicy === true || privacyPolicyGmac === true) &&
        firstName &&
        lastName &&
        email &&
        phone &&
        country)
    )
  }

  render = () => (
    <>
      <div className='g--spacer--small hide show--tablet' />
      <Card>
        <p className='g--font-h4'>
          We want to stay in touch and help you create your future
        </p>
        <div className='row row--gutters-small row--gutters-mobile-none'>
          <div className='row__column row__column--50  row__column--mobile-100'>
            <Input
              id='first-name'
              type='text'
              placeholder='First name'
              icon='user'
              value={this.state.firstName}
              onChange={this.onFirstNameChange}
              onBlur={() => {
                this.setState({
                  firstNameValid: isNameValid(this.state.firstName)
                })
              }}
              isValid={this.state.firstNameValid}
            />
          </div>
          <div className='row__column row__column--50  row__column--mobile-100'>
            <Input
              id='last-name'
              type='text'
              placeholder='Last name'
              icon='user'
              value={this.state.lastName}
              onChange={this.onLastNameChange}
              onBlur={() => {
                this.setState({
                  lastNameValid: isNameValid(this.state.lastName)
                })
              }}
              isValid={this.state.lastNameValid}
            />
          </div>
        </div>
        <Input
          id='email'
          type='email'
          placeholder='Email'
          icon='envelope'
          value={this.state.email}
          onChange={this.onEmailChange}
          onBlur={() => {
            this.setState({
              emailValid: validator.isEmail(this.state.email)
            })
          }}
          isValid={this.state.emailValid}
        />
        <Input
          id='phone'
          type='phone'
          placeholder='Mobile phone number'
          icon='phone'
          value={this.state.phone}
          onChange={this.onPhoneChange}
          onBlur={() => {
            this.setState({
              phoneValid: validator.isMobilePhone(this.state.phone)
            })
          }}
          isValid={this.state.phoneValid}
        />
        <Input
          id='country'
          placeholder='Country of residence'
          type='select'
          value={this.state.country}
          onChange={this.onCountryChange}
        >
          {countries.map(country => (
            <option
              title={country.value}
              key={country.code}
              value={country.code}
            >
              {country.value}
            </option>
          ))}
        </Input>
        {this.state.countryStateList.length > 0 && (
          <Input
            id='state'
            placeholder='State'
            type='select'
            value={this.state.countryState}
            onChange={this.onStateChange}
          >
            {this.state.countryStateList.map(state => (
              <option title={state} key={state} value={state}>
                {state}
              </option>
            ))}
          </Input>
        )}
        <hr />
        <Radio
          type='radio'
          trueLabel='Yes'
          falseLabel='No'
          idName='hult'
          onChangeTrue={this.onChecked}
          onChangeFalse={this.onUnchecked}
          label={
            <>
              I would like to receive a copy of the advanced report by email and
              for Hult International Business School and its affiliates to use
              my personal data to provide me with further information about its
              programs. Unsubscribe or Contact{' '}
              <a
                className='g--font-span-bold'
                href='https://www.hult.edu/en/contact/'
                rel='noopener noreferrer'
                target='_blank'
              >
                Hult
              </a>{' '}
              any time.
              <a
                className='g--font-span-bold'
                href='https://www.hult.edu/en/legal-privacy/'
                rel='noopener noreferrer'
                target='_blank'
              >
                {' '}
                Hult Privacy Policy
              </a>
            </>
          }
        />
        <hr />
        <Radio
          name='-1'
          type='radio'
          trueLabel='Yes'
          falseLabel='No'
          idName='gmac'
          onChangeTrue={this.onCheckedGmac}
          onChangeFalse={this.onUncheckedGmac}
          label={
            <>
              Please contact me with the latest information about management
              education, tests, events, products, and other offers from the
              Graduate Management Admission Council (GMAC) and its{' '}
              <a
                className='g--font-span-bold'
                href='https://www.gmac.com/about-us/gmac-and-its-subsidiaries'
                rel='noopener noreferrer'
                target='_blank'
              >
                Subsidiaries
              </a>
              . Unsubscribe or{' '}
              <a
                className='g--font-span-bold'
                href='
          https://www.mba.com/service/contact-us
          '
                rel='noopener noreferrer'
                target='_blank'
              >
                Contact GMAC
              </a>{' '}
              any time.{' '}
              <a
                className='g--font-span-bold'
                href='https://www.gmac.com/about-us/privacy-statement'
                rel='noopener noreferrer'
                target='_blank'
              >
                Privacy Statement
              </a>
            </>
          }
        />
        {this.showFooter() && (
          <>
            <hr />
            <Button
              className='button--wide'
              variant='cta'
              Wrapper={'button'}
              wrapperProps={{
                onClick: () => {
                  this.register()
                }
              }}
              label='Get your career plan'
              icon='arrow-right'
            />
          </>
        )}
        <hr />
        <p className='g--font-body'>
          The data behind
          <Link to='/career-explorer/data'>
            <b className='g--font-body-bold'> Career Explorer</b>
          </Link>{' '}
          is extracted from a variety of public and private big data sources in
          the US.
        </p>
      </Card>
    </>
  )
}

Register.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  linkedinToken: PropTypes.shape({
    access_token: PropTypes.string,
    expires_at: PropTypes.string
  }),
  callRegister: PropTypes.func.isRequired,
  callSetLinkedInAuthCode: PropTypes.func.isRequired,
  callGetLinkedInProfile: PropTypes.func.isRequired,
  callHubSportApi: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  linkedinToken: state.linkedin.authToken || {},
  firstName: state.user.firstName || '',
  lastName: state.user.lastName || '',
  email: state.user.email || '',
  country: state.user.country || '',
  state: state.user.state || '',
  privacyPolicy: state.user.privacyPolicy || false,
  privacyPolicyGmac: state.user.privacyPolicyGmac
})

const mapDispatchToProps = dispatch => ({
  callRegister: user => {
    dispatch(registerUser(user))
    dispatch(save())
  },
  callSetLinkedInAuthCode: code => {
    dispatch(setLinkedInAuthCode(code))
  },
  callGetLinkedInProfile: () => {
    dispatch(getLinkedInProfile()).then(() => {
      dispatch(save())
    })
  },
  callHubSportApi: user => {
    dispatch(hubSpotApi(user))
  }
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Register)
)
